function Contact() {
  return (
    <section className="container about-content">
      <h1 className="about-title">Contact</h1>
      <p className="about-text">
        Tu peux m'envoyer un message directement par email via ce formulaire.
      </p>

      <form
        className="contact-form"
        action="mailto:info@growgrind.net"
        method="GET"
        encType="text/plain"
      >
        <div className="contact-field">
          <label htmlFor="name">Nom</label>
          <input id="name" name="Nom" type="text" placeholder="Ton nom" required />
        </div>

        <div className="contact-field">
          <label htmlFor="email">Ton email</label>
          <input id="email" name="Email" type="email" placeholder="ton.email@example.com" required />
        </div>

        <div className="contact-field">
          <label htmlFor="subject">Sujet</label>
          <input id="subject" name="Sujet" type="text" placeholder="Sujet du message" required />
        </div>

        <div className="contact-field">
          <label htmlFor="message">Message</label>
          <textarea id="message" name="Message" placeholder="Écris ton message ici..." rows={5} required />
        </div>

        <button type="submit" className="btn-cta">Envoyer le message</button>
      </form>
    </section>
  );
}

export default Contact;
